import { makeLazyComponent } from '../../utils/lazy';

export const LazyOrderForm = makeLazyComponent(
  async () => (await import(/* webpackChunkName: "cart" */ './cart')).Cart,
);
